/**
 * Formateo de consumo de datos para el indicador del header.
 *
 * La página `/admin/consumo` lleva su propia copia en JS plano (es HTML
 * standalone, fuera del bundle) y el informe que recibe el cliente usa este
 * mismo formato: unidad escalada y coma decimal española. `formatConsumo.test.ts`
 * compara las dos implementaciones para que no se separen en silencio.
 */
export function formatConsumo(mb: number | null | undefined): string {
  const n = Number(mb) || 0;
  if (n >= 1024) return (n / 1024).toLocaleString('es-ES', { maximumFractionDigits: 1 }) + ' GB';
  if (n < 1) return (n * 1024).toLocaleString('es-ES', { maximumFractionDigits: 0 }) + ' KB';
  return n.toLocaleString('es-ES', { maximumFractionDigits: 1 }) + ' MB';
}
